export default "__VITE_ASSET__CrzEsyZR__"